export default "__VITE_ASSET__Dd7kHkLG__"